import { EXPAND_SECTION, COLLAPSE_SECTION, TOGGLE_SECTION, PUSH_SECTION } from './AccordionConstants';
import _ from 'lodash';

export default (state = {
    sections: {}
}, action) => {
    switch (action.type) {
        case EXPAND_SECTION:
            if (_.has(state, ['sections', action.payload])) {
                const newState = _.cloneDeep(state);
                _.set(newState, ['sections', action.payload, 'isExpanded'], true);
                
                return newState;
            }
            return state;
        case COLLAPSE_SECTION:
            if (_.has(state, ['sections', action.payload])) {
                const newState = _.cloneDeep(state);
                _.set(newState, ['sections', action.payload, 'isExpanded'], false);

                return newState;
            }
            return state;
        case TOGGLE_SECTION:
            if (_.has(state, ['sections', action.payload])) {
                const newState = _.cloneDeep(state);
                const isExpanded = _.get(newState, ['sections', action.payload, 'isExpanded'], false);
                _.set(newState, ['sections', action.payload, 'isExpanded'], !isExpanded);

                return newState;
            }
            return state;
        case PUSH_SECTION:
        {
            const newState = _.cloneDeep(state);
            _.set(newState, ['sections', action.payload.id, 'isExpanded'], action.payload.isExpanded);

            return newState;
        }
        default:
            return state;
    }
};
